import React from "react"
import styled from "react-emotion"
// eslint-disable-next-line
import globalStyles from "ui/styleHelpers/globalStyles"

import { Icon } from "ui"

export const Hamburger = props => {
    const Wrapper = styled("span")`
        @media (min-width: 768px) {
            display: none;
        }
        height: 50px;
        width: 50px;
        margin: 10px;
        font-size: 30px;
        padding: 5px;
    `
    const hamburgerInWrapper = (
        <Wrapper {...props}>
            <Icon icon="bars" />
        </Wrapper>
    )
    return hamburgerInWrapper
}

export const CloseButton = props => {
    const Wrapper = styled("span")`
        @media (min-width: 768px) {
            display: none;
        }

        height: 50px;
        width: 160px;
        margin: 10px;
        font-size: 30px;
        padding: 5px;
        color: #777;
        text-align: right;
    `
    return (
        <Wrapper {...props}>
            <Icon icon="times" />
        </Wrapper>
    )
}

export const Logo = styled("img")`
    height: 65px;
    width: 184px;
    padding: 17px;
`

export const Page = styled("div")`
    display: flex;
    height: 100vh;
    width: 100vw;
    flex-direction: column; /*places the left and right headers above the bottom content*/
`
export const Main = styled("div")`
    height: 100%; /*allows both columns to span the full height of the browser window*/
    display: flex;
    flex-direction: row; /*places the left and right headers above the bottom content*/
`

export const Header = styled("div")`
    flex-shrink: 0;
    flex-basis: 65px;
    display: inline-flex;
    // background: white;
    // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    // z-index: 1; // Bring the shadow over the sidebar
    background: ${props => props.theme.backgroundColor};
    height: 65px;
    width: 100%;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    background: #866c6c;
    background-image: ${props =>
        props.color === "yellow"
            ? "-webkit-linear-gradient(150deg, rgb(232, 181, 39) 45%, rgb(247, 195, 50) 45%)"
            : props.color === "red"
                ? "-webkit-linear-gradient(150deg, rgb(255, 78, 26) 45%, rgb(228, 67, 20) 45%)"
                : "-webkit-linear-gradient(150deg,#2980b9 45%,#216ba5 45%)"};
`
export const ClearHeader = styled("div")`
    flex-shrink: 0;
    display: inline-flex;
    flex-basis: 65px;
    background: ${props => props.theme.backgroundColor};
    background-color: #013a6b;
    background-image: -webkit-linear-gradient(30deg, #013a6b 50%, #004e95 50%);
`

export const ContentWrapper = styled("div")`
    flex-grow: 1; /*ensures that the container will take up the full height of the parent container*/
    overflow-y: auto; /*adds scroll to this container*/
    width: 100%;
    height: 100%;
    background: #f9f9f9;
`

export const Content = styled("div")`
    padding-top: ${props => props.theme.large};
    padding-left: calc((100% - 1000px) / 2);
    padding-right: calc((100% - 1000px) / 2);
    padding-bottom: 32px;
    margin: 0px 20px;
    display: flex;
    flex-direction: column;
`

export const HeaderWrapper = styled("div")`
    padding-top: 5px;
    padding-left: calc((100% - 1000px) / 2);
    padding-right: calc((100% - 1000px) / 2);
    margin: 0px 20px;
`



// WEBPACK FOOTER //
// ./src/features/studio/ui/Layout.js